var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LaunchWeApp',{staticClass:"launch",attrs:{"btn-text":_vm.btnText,"username":_vm.username,"path":_vm.path},on:{"onSuccess":_vm.onSuccess,"onError":_vm.onError},nativeOn:{"click":function($event){return _vm.onLaunchWeAppTouch($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }